import r2wc from '@r2wc/react-to-web-component'
import { initializeSentry } from './sentry'
import { App } from './App'

initializeSentry()

customElements.define(
  'docmine-scrollstory',
  r2wc(App, {
    props: {
      lang: 'string',
      scrollstoryid: 'string',
      theme: 'string',
    },
  })
)
